module.exports = __webpack_public_path__ + "img/flash-off.8493c71d.svg";